module.exports = __webpack_public_path__ + "img/play.26b91da6.png";